import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import * as fromGrow from '../../grow.reducers';
import * as fromAppRoot from '@app/app.reducers';

import * as GrowActions from '../../grow-actions';
import { GrowService } from '../../services/grow.service';

@Component({
  selector: 'app-grow-intro',
  templateUrl: './grow-intro.component.html',
  styleUrls: ['./grow-intro.component.scss'],
  standalone: false
})
export class GrowIntroComponent implements OnInit, OnDestroy {
  protected readonly onDestroy$ = new Subject<void>();
  growIntroLoading$: Observable<boolean>;

  constructor(
    private store: Store,
    private router: Router,
    private growService: GrowService
  ) {}

  ngOnInit(): void {
    this.store
      .select(fromAppRoot.selectCustomerAndGrowAccount)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(({ customer, growAccount }) => {
        if (!growAccount) {
          return;
        }

        this.router.navigate([this.growService.getTargetUrlBasedOnStepStatus(growAccount, customer)]);
      });
    this.growIntroLoading$ = this.store.select(fromGrow.selectGrowIntroLoading);
  }

  onSubmit(data): void {
    this.store.dispatch(GrowActions.createGrowAccount());
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
